import {Injectable} from '@angular/core';
import {Router, Routes} from '@angular/router';
import * as _ from 'lodash';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { LocalStorageService } from 'ngx-webstorage';

import { menu_permissions } from '../../theme.constants';

@Injectable()
export class BaMenuService {
  menuItems = new BehaviorSubject<any[]>([]);

  protected _currentMenuItem = {};

  private user_data;
  private permissions:string[];

  constructor(
    private _router:Router,
    private _localStorage: LocalStorageService
  ) {
    var user_data = _localStorage.retrieve('user_data');
    var permissions = _localStorage.retrieve('permissions');
    if(user_data!=null)
      this.user_data = user_data;
    if(permissions!=null)
      this.permissions = permissions;

    _localStorage.observe('user_data')
      .subscribe((user_data) => this.user_data = user_data);

    _localStorage.observe('permissions')
      .subscribe((permissions) => this.permissions = permissions);
  }

  /**
   * Updates the routes in the menu
   *
   * @param {Routes} routes Type compatible with app.menu.ts
   */
  public updateMenuByRoutes(routes: Routes) {
    let convertedRoutes = this.convertRoutesToMenus(_.cloneDeep(routes));
    this.menuItems.next(convertedRoutes);
  }

  public convertRoutesToMenus(routes:Routes):any[] {
    let items = this._convertArrayToItems(routes);
    return this._skipEmpty(items);
  }

  public getCurrentItem():any {
    return this._currentMenuItem;
  }

  public selectMenuItem(menuItems:any[]):any[] {
    let items = [];

    menuItems.forEach((item) => {
      this._selectItem(item);
      if (item.selected || (item.route.path=="datasurveydesign" && 
          this._router.url=="/pages/datasurveydesign/questions") ||
          (item.route.path=="adminsurveyplans" && 
          (this._router.url=="/pages/adminsurveyplans/plantarget" ||
          this._router.url=="/pages/adminsurveyplans/planauditor"))) {
        item.selected = true;
        this._currentMenuItem = item;
      }

      if (item.children && item.children.length > 0) {
        item.children = this.selectMenuItem(item.children);
      }
      
      if(
        ( 
          item.route.path!="personal" &&
          item.route.path!="user" &&
          item.route.path!="fichajesSinPersona" &&
          item.route.path!="fichajesARevisar" &&
          this.hasPermission(item)
        ) 
        ||
        ( 
          item.route.path=="personal" &&
          this.user_data!=null && 
          this.user_data.read_only_permission==false
        ) 
        ||
        (
          // Change 2026-10-correcciones-campania-2 (S1): administrador sin solo lectura
          item.route.path=="user" && 
          this.user_data!=null && 
          this.user_data.is_admin &&
          !this.user_data.read_only_permission
        )
        ||
        (
          // Change 2026-10-fichajes-sin-persona: grupo de cierre de jornadas o administrador
          item.route.path=="fichajesSinPersona" &&
          this.user_data!=null &&
          this.user_data.ver_fichajes_sin_persona
        )
        ||
        (
          // Change 2026-10-correcciones-campania: el mismo permiso que Fichajes sin persona
          item.route.path=="fichajesARevisar" &&
          this.user_data!=null &&
          this.user_data.ver_fichajes_a_revisar
        )        
      )
        items.push(item);
    });
    return items;
  }

  private hasPermission(item):boolean{
    if(item.children!=null){
      for(var child of item.children){
        if(this.hasPermission(child))
          return true;
      }
      return false;
    }

    var permissionObj = menu_permissions[item.route.path];
    if(permissionObj!=null){
      for(var permission of this.permissions){
        if(this.isTherePermission(permission, permissionObj))
          return true;
      }
      return false;
    }else
      return true;
  }

  private isTherePermission(permission:string, permissionObj):boolean{
    for(var index in permissionObj){
      var valuePermission = permissionObj[index];
      if(permission.endsWith('.'+valuePermission))
        return true;
    }
    return false;
  }

  protected _skipEmpty(items:any[]):any[] {
    let menu = [];
    items.forEach((item) => {
      let menuItem;
      if (item.skip) {
        if (item.children && item.children.length > 0) {
          menuItem = item.children;
        }
      } else {
        menuItem = item;
      }

      if (menuItem) {
        menu.push(menuItem);
      }
    });

    return [].concat.apply([], menu);
  }

  protected _convertArrayToItems(routes:any[], parent?:any):any[] {
    let items = [];
    routes.forEach((route) => {
      items.push(this._convertObjectToItem(route, parent));
    });
    return items;
  }

  protected _convertObjectToItem(object, parent?:any):any {
    let item:any = {};
    if (object.data && object.data.menu) {
      // this is a menu object
      item = object.data.menu;
      item.route = object;
      delete item.route.data.menu;
    } else {
      item.route = object;
      item.skip = true;
    }

    // we have to collect all paths to correctly build the url then
    if (Array.isArray(item.route.path)) {
      item.route.paths = item.route.path;
    } else {
      item.route.paths = parent && parent.route && parent.route.paths ? parent.route.paths.slice(0) : ['/'];
      if (!!item.route.path) item.route.paths.push(item.route.path);
    }

    if (object.children && object.children.length > 0) {
      item.children = this._convertArrayToItems(object.children, item);
    }

    let prepared = this._prepareItem(item);

    // if current item is selected or expanded - then parent is expanded too
    if ((prepared.selected || prepared.expanded) && parent) {
      parent.expanded = true;
    }

    return prepared;
  }

  protected _prepareItem(object:any):any {
    if (!object.skip) {
      object.target = object.target || '';
      object.pathMatch = object.pathMatch  || 'full';
      return this._selectItem(object);
    }

    return object;
  }

  protected _selectItem(object:any):any {
    object.selected = this._router.isActive(this._router.createUrlTree(object.route.paths), object.pathMatch === 'full');
    return object;
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/services/baMenu/baMenu.service.ts